import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {TranslocoService} from '@ngneat/transloco';
import {AbstractComponent} from '../abstract.component';
import {EventItem, Lookups, RaceAdditionalPricingItem, RacePricingItemValue} from "@model";
import {getLanguageValue, transformValueAndCurrency} from "@utility";

@Component({
    selector: 'app-additional-pricing-item-value-input',
    templateUrl: './additional-pricing-item-value-input.component.html',
    styleUrls: ['./additional-pricing-item-value-input.component.scss'],
    standalone: false
})
export class AdditionalPricingItemValueInputComponent extends AbstractComponent implements OnInit, OnChanges {
  @Input() inputForm: FormGroup<any> | undefined;
  @Input() fieldKey: string | undefined;
  @Input() fieldConfig: RaceAdditionalPricingItem | undefined;
  @Input() event: EventItem | undefined;
  @Input() currencies: Lookups[] = [];

  options: RacePricingItemValue[] | RaceAdditionalPricingItem[] = [];
  fieldLabel: string = "";
  labels: string[] = [];

  constructor(public translocoService: TranslocoService) {
    super();
  }

  ngOnInit(): void {
    this.initFields();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['fieldConfig']?.currentValue !== changes['fieldConfig']?.previousValue) {
      this.initFields()
    }
  }

  initFields() {
    this.options = this.getOptions();
    this.fieldLabel = this.getFieldLabel();
    this.labels = this.getLabels();
  }


  getLabel(object: RaceAdditionalPricingItem | RacePricingItemValue): string {
    let fieldConfigName: string = getLanguageValue(this.fieldConfig?.name, this.fieldConfig?.nameEng, this.fieldConfig?.nameIta, this.fieldConfig?.nameSlo, this.fieldConfig?.nameSr, this.fieldConfig?.nameBs, this.translocoService.getActiveLang()) ?? "";
    let optionName = getLanguageValue(object?.name, object?.nameEng, object?.nameIta, object?.nameSlo, object?.nameSr, object?.nameBs, this.translocoService.getActiveLang()) ?? "";
    let price: string = "";
    if (this.fieldConfig?.priceConstant === true) {
      price = transformValueAndCurrency(this.fieldConfig?.price, this.translocoService.getActiveLang()) + " " + this.getCurrencyLabel();
    } else if (!!object.price) {
      price = transformValueAndCurrency(object.price, this.translocoService.getActiveLang()) + " " + this.getCurrencyLabel();
    }
    return `${fieldConfigName} : ${optionName} - ${price}`;
  }

  getCurrencyLabel(): string {
    const curr = this.currencies.find((currency: Lookups) => currency.id === this.event?.currency);
    return curr?.name ?? "";
  }

  getFieldLabel(): string {
    let label = getLanguageValue(this.fieldConfig?.name, this.fieldConfig?.nameEng, this.fieldConfig?.nameIta, this.fieldConfig?.nameSlo, this.fieldConfig?.nameSr,  this.fieldConfig?.nameBs, this.translocoService.getActiveLang(), this.fieldConfig?.name) ?? "";
    let price: string | undefined;
    if (!(this.fieldConfig?.priceConstant === false) && !(this.fieldConfig?.pricingItemValues?.length) && this.fieldConfig?.price) {
      price = transformValueAndCurrency(this.fieldConfig?.price, this.translocoService.getActiveLang()) + " " + this.getCurrencyLabel();
    }
    return `${label}${price ? ' - ' : ''}${price ?? ''}`;
  }

  getOptions(): RacePricingItemValue[] | RaceAdditionalPricingItem[] {
    return this.fieldConfig?.pricingItemValues?.map((option: RacePricingItemValue) => {
      return option;
    }) ?? [];
  }

  getLabels(): string[] {
    return this.options.map(option => this.getLabel(option))
  }
}
